@if (type === 'time') {
  <!-- Use custom time picker for cross-browser compatibility -->
  <app-time-picker
    [label]="label"
    [placeholder]="placeholder"
    [showAsterisk]="showAsterisk"
    [disabled]="effectiveDisabled || isReadOnly"
    [errorMessage]="errorMessage"
    [showError]="showError"
    [selectedDate]="selectedDate"
    [ngModel]="value"
    (ngModelChange)="onTimeChange($event)"
  ></app-time-picker>
} @else {
  <label
    class="block text-xs font-semibold text-[#25282D] mb-1"
    [ngClass]="labelClass"
  >
    {{ label }}
    @if (showAsterisk) {
      <span class="text-orange-500  text-xs font-semibold">*</span>
    }
  </label>

  <div class="relative w-full">
    <input
      [type]="type"
      [placeholder]="placeholder"
      [disabled]="effectiveDisabled"
      [(ngModel)]="value"
      [readonly]="isReadOnly"
      [step]="step"
      [min]="min"
      [max]="max"
      (input)="onInputEvent($event)"
      (blur)="onBlurEvent($event)"
      [ngClass]="{
        '!pl-8': showSearchIcon,
        '!pl-2': !showSearchIcon,
        'placeholder:text-[#25282D] bg-[#E7E7EF] select-text pointer-events-none cursor-not-allowed opacity-90': isReadOnly,
        'bg-[#F8F8FE]': !isReadOnly,
        'pr-2': type === 'date',
        'border-red-500 focus:!border-red-500 focus:ring-red-500': showError && errorMessage
      }"
      class="w-full text-[#25282D] text-[12px] px-2 py-[7px] border border-[#DBE0E6] focus:outline-none focus:!border-[#C7B1FF] focus:ring-[#C7B1FF] rounded-[5px] placeholder:text-[12px] placeholder-[#96A0B5] focus:shadow focus:shadow-[#F0F0F0]"
      [ngClass]="inputClass"
    />

    <!-- Error Message -->
    @if (showError && errorMessage) {
      <div class="mt-1 text-xs text-red-500">
        {{ errorMessage }}
      </div>
    }

    <!-- Search Icon -->
    @if (showSearchIcon) {
      <i class="bi bi-search absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
    }
  </div>
}

